const { connect } = require('react-redux');
const gameOverComponent = require('../component/gameOverComponent').default;
const { actions } = require('../../../../reducers').default;
const { modalType } = require('../../../../define/screenType').default;
// ======================

const mapStateToProps = (state) => {
    const { screenState, playerState, gameState, appState } = state;
    return {
        isModalOpen: screenState.modal === modalType.MODAL_GAME_OVER,
        soundEnable: appState.soundEnable,
        playerState,
        gameState
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleContinueClick: (currentStage) => {
            dispatch(actions.continueStage(currentStage));
            dispatch(actions.modalDisable());
            dispatch(actions.modalEnable(modalType.MODAL_STAGE_START));
        },
        handleTitleClick: () => {
            dispatch(actions.modalDisable());
            dispatch(actions.modalEnable(modalType.MODAL_RESULT));
        }
    };
};

export const GameOverContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(gameOverComponent);